import React, { useContext, useState, useRef } from "react";
import FuncionesContext from "../../../context/FuncionesContext";
import TextFieldEditable from "../../../components/TextFieldEditable";
import { TextField } from "@mui/material";
import "../Vista.scss";
import { getAtributo, validarRegex } from "../../../context/FuncionesContext";
import { useRefDataStore } from "../../../../..";

const InputTextEditable = ({
  data,
  cab,
  campokey,
  Context,
  id_elemento,
  valor,
  updateid,
}) => {
  const { superSubmit } = useContext(FuncionesContext);
  const [v, setStore] = useRefDataStore((s) => s[data._key + campokey]);
  const [update_id] = useRefDataStore(
    (s) => s[data._key + cab.update_id_alias]
  );
  const { opciones } = useContext(Context);
  const prefijo_usar = getAtributo("prefijo_usar", data, cab) === "s";
  const prefijo = getAtributo("prefijo", data, cab) ?? "";

  const normalizarValor = (val) => {
    if (cab.solo_mayus === "s" && typeof val === "string") {
      return val.toUpperCase();
    }

    return val;
  };

  const separarPrefijo = (val) => {
    if (typeof val !== "string") return val;
    if (prefijo_usar && val.startsWith(prefijo)) {
      return val.slice(prefijo.length);
    }
    return val;
  };

  const combinarPrefijo = (val) => {
    if (!prefijo_usar || typeof val !== "string") return val;
    return prefijo + val;
  };

  const valorPersistido = v ?? valor;
  const valorEditable = normalizarValor(separarPrefijo(valorPersistido));

  const [value, setValue] = useState(valorEditable);
  const [lastValue, setLastvalue] = useState(valorEditable);
  const [updateId, setUpdateId] = useState(update_id ?? updateid);

  const [error, setError] = useState(false);
  const [helper, setHelper] = useState("");

  const nombre = (() => {
    if (cab.nombre_alias) return data[cab.nombre_alias];
    return cab.nombre;
  })();

  const icono_obligatorio =
    data[cab.id_a + "_icono_obligatorio"] === "s" ||
    cab.icono_obligatorio === "s";

  const handleCancelar = () => {
    const valorAnterior = normalizarValor(separarPrefijo(v ?? valor));

    setValue(valorAnterior);

    const inputElement = document.getElementById(id_elemento + "_field");
    if (inputElement) inputElement.value = valorAnterior;
  };

  const submittingRef = useRef(false);
  const ignoreNextBlurRef = useRef(false);

  const handleGuardar = async (e) => {
    const isEnter = e.type === "keydown";
    const isBlur = e.type === "blur";

    if (isEnter) {
      ignoreNextBlurRef.current = true;
      e.preventDefault();
    }

    if (isBlur && ignoreNextBlurRef.current) {
      ignoreNextBlurRef.current = false;
      return;
    }

    if (submittingRef.current) return;
    submittingRef.current = true;

    const val = normalizarValor(e.target.value);
    const valorAGuardar = combinarPrefijo(val);
    setValue(val);
    e.target.value = val;

    if (val === lastValue || (val === "" && lastValue === null)) {
      submittingRef.current = false;
      return;
    }

    if (val === null || lastValue?.toString() === val.toString().trim()) {
      submittingRef.current = false;
      return;
    }

    if (!validarRegex(val, cab.validacion_regex, cab)) {
      setError(true);
      setHelper(cab.helperText || "Formato inválido");
      handleCancelar();
      submittingRef.current = false;
      return;
    }

    const { id_a } = cab;

    superSubmit({
      valor: valorAGuardar,
      id_a,
      update_id: updateId,
      handleCancelar,
      cab,
      data,
    })
      .then((result) => {
        setLastvalue(() => val);
        setStore({ [data._key + campokey]: valorAGuardar });

        if (!updateId) {
          setStore({
            [data._key + cab.update_id_alias]: result.data.registro.id,
          });
          setUpdateId(result.data.registro.id);
        }
      })
      .catch((err) => {
        console.log("Cancelado ", err);
        handleCancelar();
      })
      .finally(() => {
        submittingRef.current = false;
      });
  };

  const align = (() => {
    let clas = "align-left";
    if (cab.align?.trim() === "center") clas = "align-center";
    if (cab.align?.trim() === "right") clas = "align-right";
    return clas;
  })();

  const disabled = (() => {
    if (data[cab.id_a + "_disabled"])
      return data[cab.id_a + "_disabled"] === "s";
    if (cab.disabled) return cab.disabled === "s";
    return false;
  })();

  return (
    <div id={id_elemento} className="tarjeta_grid_item_label_item">
      {nombre && nombre.trim() && opciones.tipo.id === 6 ? (
        <div className="vista_label">
          <p
            style={{
              maxHeight: "25px",
              position: "relative",
              top: "2px",
              wordBreak: "break-all",
            }}
            className="suW"
          >
            {nombre}:
          </p>
        </div>
      ) : null}

      <div
        className={`tarjeta_grid_item_label_item ${cab.className}`}
        style={{ display: "flex", alignItems: "flex-start", gap: "4px" }}
      >
        {prefijo_usar ? (
          <TextField
            value={prefijo}
            disabled
            size="small"
            style={{ backgroundColor: "#99989861", width: "30%" }}
          />
        ) : null}
        <div
          style={{
            position: "relative",
            display: "flex",
            width:
              cab.width_input && cab.width_input.trim() !== ""
                ? cab.width_input
                : prefijo_usar
                  ? "70%"
                  : "100%",
          }}
        >
          <TextFieldEditable
            disabled={disabled}
            value={value}
            error={error}
            helperText={""}
            lastValue={lastValue}
            setValue={(val) => setValue(normalizarValor(val))}
            onEnter={handleGuardar}
            onBlur={handleGuardar}
            maxCaracteres={parseInt(cab.maximo_caracteres)}
            idInput={id_elemento + "_field"}
            className={`_textFieldEditable ${align}`}
            inputClassName={`${cab.input_class_caja ?? ""}${
              error ? " input_error" : ""
            }`}
          />

          {error && (
            <small
              style={{
                position: "absolute",
                left: 0,
                bottom: 0,
                color: "#d32f2f",
                margin: 0,
                height: 0,
                zIndex: 9,
                width: "max-content",
              }}
            >
              {helper}
            </small>
          )}
          {icono_obligatorio && <span className="icono_obligatorio ml-1">*</span>}
        </div>

      </div>
    </div>
  );
};

export default InputTextEditable;
